import React, {FC} from "react";
import {useTranslation} from "react-i18next";
import UserSessionMenu from "../UserSessionMenu/UserSessionMenu";
import s from "./LoginSessionPanel.module.css";
import {Button, notification} from "@p4ma/p4md-react";
import {useAuthorization} from "../../api/useAuthorization";

/**
 * Панель на /login при живой cookie-сессии без access к модулю Auth.
 * Типичный сценарий после Impersonate под обычным пользователем.
 */
const LoginSessionPanel: FC = () => {
  const {t} = useTranslation("common");
  const {signOut, isImpersonating, endImpersonation, loading} = useAuthorization();

  const buttonDisabled = loading.endImpersonation || loading.impersonateUser || loading.signOut;

  const handleEndImpersonation = () => {
    notification.info({
      key: "endImpersonation",
      message: t("impersonate.end.loading.message"),
      description: t("impersonate.end.loading.description"),
      duration: 0
    });
    endImpersonation();
    notification.close("endImpersonation");
  };

  return (
    <div className={s.panel} data-testid="login-session-panel">
      <div className={s.user_menu}>
        <UserSessionMenu />
      </div>
      <p className={s.no_access}>
        {isImpersonating
          ? t("impersonate.session.noModuleAccess")
          : t("messages.userAccessIsNotAllowed")}
      </p>
      {isImpersonating ? (
        <Button
          type="ghost"
          onClick={handleEndImpersonation}
          loading={loading.endImpersonation}
          className={s.button}
          disabled={buttonDisabled}
        >
          {t("impersonate.end.action")}
        </Button>
      ) : null}
      <Button
        type="primary"
        onClick={signOut}
        loading={loading.signOut}
        className={s.button}
        disabled={buttonDisabled}
      >
        {t("logout")}
      </Button>
    </div>
  );
};

export default LoginSessionPanel;
